import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function SubscriptionTerms({ subscription, language, newPurchase = false }) {
  const { t } = useTranslation();
  if (!newPurchase && !subscription?.contract_term_end) return null;
  const format = (value) => new Intl.DateTimeFormat(language || "en", {
    dateStyle: "medium", timeStyle: "short",
  }).format(new Date(value));
  return (
    <>
      <Typography variant="body2">
        {t("12-month term, billed monthly. Renews for another 12 months unless canceled at least 30 days before the term ends.")}
      </Typography>
      {subscription?.contract_term_end && (
        <Typography variant="body2">
          {t("Contract term ends")}: {format(subscription.contract_term_end)}
        </Typography>
      )}
      {subscription?.cancellation_deadline && !subscription.cancellation_scheduled && !subscription.cancel_at && !subscription.cancel_at_period_end && (
        <Typography variant="body2">
          {t("Cancellation deadline")}: {format(subscription.cancellation_deadline)}
        </Typography>
      )}
    </>
  );
}
